import React, { useEffect, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  INSTANCE_LABELS_LAWYER,
  PROCEDURE_STEPS_INDEX,
  PROCEDURE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/constants';
import JudgementAdd from 'containers/LawyerLegalProceedingsPage/judgementAdd';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import * as util from 'containers/RecapManagerPage/utils';
import { get, isEmpty } from 'lodash';
import {
  IUploadedDocument,
  IJudgementAdd,
  ICurrentSteps,
  JudgementOnMeritsType,
  IAppealPayload,
} from 'containers/LawyerLegalProceedingsPage/typings';

import {
  StyledSahamTabs,
  StyledSahamAppelTabs,
} from 'components/SahamTabs/styled-components';
import ToggleTabs from 'components/ToggleTabs';
import routesHelper from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import LawyerExpertReport from 'containers/LawyerLegalProceedingsPage/ExpertReport';
import JudgementOnMerits from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits';
import {
  getJomVehicles,
  getJomVictims,
  getJudgementAddDocuments,
  isJudiciaryProcessLawyerCode,
  resolveJudgementAddDocs,
  showExpertReport,
  showJudgementOnMerits,
  ShowExpertExpertise,
  isCivilProceedingCheck,
  constructAssignedLawyer,
  checkIsAssignedLawyer,
  isCivilProceedingCommercialCheck,
  resolveDisplayJomForm,
  proceedingLabels,
  isPendingApprovalClaim,
  getExpertExpertise,
  formatRenderJudgementOnMerits,
  sortJudgement,
} from 'containers/LawyerLegalProceedingsPage/utils';
import { ExpertReportType } from 'containers/common/LegalProceedings/ExpertReport/typings';
import AppealAdd from 'containers/LawyerLegalProceedingsPage/AppealAdd';
import { LISTINGS } from 'containers/data-structure';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import useDeepCompareEffect from 'use-deep-compare-effect';
import LawyerExpertReportAppeal from 'containers/LawyerLegalProceedingsPage/AppealExpert/index';
import JudgementOnMeritsAppeal from 'containers/LawyerLegalProceedingsPage/AppealOnMerits/index';
import CivilProceedingRecap from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import Contestation from 'containers/LawyerLegalProceedingsPage/Contestation';
import {
  filterVehicle,
  filterVictim,
  isBlockStatusClaim,
} from 'containers/CourtManagerLegalProceedings/utils';
import ExpertReport from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport';
import { extractOpposingParties } from 'containers/PreOpeningPage/utils';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/JudgementAdd/constants';
import { getBeneficiaries } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/hooks';
import { ClaimRecapType } from 'typings/claimTypes';

export interface LegalProceedingsPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  requestClaimRecap: Function;
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  match: { params: { claimId: number; procedureType: string } };
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  requestCreateJudgementAdd: Function;
  requestGetJudgementAdd: Function;
  judgementAdd: IJudgementAdd | { status: string };
  sagis_code: string | undefined;
  judgementAddClone: any;
  currentSteps: ICurrentSteps[];
  getLegalProceedingsSteps: Function;
  documentId: string;
  setDocumentId: Function;
  requestCreateExpertiseRaport: Function;
  requestCreateJudgementOnMerits: Function;
  requestGetExpertiseRaport: Function;
  expertiseReport: ExpertReportType;
  requestGetJudgementOnMerits: Function;
  judgementOnMerits: JudgementOnMeritsType;
  requestCreateJudgementAppeal: Function;
  requestGetJudgementAppeal: Function;
  judgementAppeal: IAppealPayload;
  dahirAmount: [];
  requestGetDahirAmount: Function;
  currentTabInstance: string;
  setCurrentInstanceTab: Function;
  requestGetCivilProceeding: Function;
  civilProceeding: [];
  judiciaryProcessId: number;
  corporealLawyers: any;
  requestInsertDahirAmountJom: Function;
  requestGetDahirAmountCorpo: Function;
  dahirAmountsCorpo: any;
  updateContestation: Function;
  requestUploadContestationDocument: Function;
  requestGetJudgementAddAppeal: Function;
  requestCreateMultipleJudgementAdd: Function;
  judgementAddAppeal: any;
  requestAddSupportDocument?: Function;
  requestCivilPartySupportDocument?: Function;
  requestAddExpertiseSupportDocument?: Function;
  requestAddJudgementOnMeritsSupportDocument: Function;
  requestUpdateJudgementAdd: Function;
  requestValidateJudgementOnMerits?: Function;
  requestValidateExpertReport?: Function;
  requestUpdateJudgementAddDocument: Function;
  currentJudiciaryProcess: any;
  requestGetJudgementOnMeritsMultiple: Function;
  judgementOnMeritsMultiple: any;
  appealOnMeritsMultiple: any;
  requestGetAppealOnMeritsMultiple: Function;
  expertExpertise: any;
  handleOpenUpdateFormCivilProceeding: Function;
  setDialogOpenFirmReference?: Function;
  loaders: any;
  sagisInfo: any;
  keycloakToken: any;
  feeNotes: any;
  onPressInstructions: () => void;
  isAssignedLawyer?: boolean;
  instructions: any;
  requestCreateIncomeCertificate: Function;
  requestGetExpertiseReportAppeal: any;
  expertiseRaportAppeal: any;
  requestGetReportsPolicy: Function;
  requestUpdateIncomeCertificate: Function;
  requestGetClaimCivilParty: Function;
  claimCivilParty: any;
  onPressFeeNote: () => void;
  requestFeeNotesByClaimNumb: Function;
  requestGetDocByDocumentumId: Function;
  requestGetJudgements: Function;
  currentTabLawyer: any;
}

export const LegalProceedingsPage: React.FC<LegalProceedingsPageProps> = (
  props,
): JSX.Element => {
  const { judgementOnMerits } = props.judgementOnMerits;
  const firstJom =
    get(props, 'judgementOnMeritsMultiple.judgementOnMerits', []).find(
      (jom: any) => jom.isFirst,
    ) || {};

  const firstJomAppeal =
    get(props, 'appealOnMeritsMultiple.judgementOnMerits', []).find(
      (jom: any) => jom.isFirst,
    ) || {};

  const currentJomMultiple = isEmpty(firstJomAppeal)
    ? firstJom
    : firstJomAppeal;

  const judgementOnMeritsMultiple = get(
    props.judgementOnMeritsMultiple,
    'judgementOnMerits',
    [],
  ).filter((jom: any) => !jom.isFirst);

  const appealOnMeritsMultiple = get(
    props.appealOnMeritsMultiple,
    'judgementOnMerits',
    [],
  ).filter((jom: any) => !jom.isFirst);
  const [stakeholders, setStakeholders] = React.useState([] as SagisConfig[]);
  React.useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = util.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings]);
  const claimId = get(props, ['match', 'params', 'claimId']);
  const [jomLabels, setJomLabels] = useState([]);
  const [jomAppealLabels, setJomAppealLabels] = useState([]);
  const [currentActiveTab, setCurrentActiveTab] = useState(
    PROCEDURE_STEPS_INDEX['FIRST_INSTANCE'],
  );
  const [currentJom, setCurrentJom] = useState({});
  const [associatedVictims, setAssociatedVictims] = React.useState([]);
  const getJomDeceasedVictims = (judgementAdd: any, jomId: number) => {
    const beneficiaries = getBeneficiaries(judgementAdd, jomId);
    return beneficiaries.map((el: any) => get(el, 'beneficiary.victim.id'));
  };

  const getJomDeceasedVictimsAppeal = (judgementAdd: any, jomId: number) => {
    const beneficiaries = getBeneficiaries(judgementAdd, jomId);
    return beneficiaries.map((el: any) => get(el, 'beneficiary.victim.id'));
  };
  const claimNumber = get(props.claimRecap['claim'], 'claimNumber', '');

  useEffect(() => {
    if (props.judiciaryProcessId) {
      props.getLegalProceedingsSteps(claimId, props.judiciaryProcessId);
      props.requestClaimRecap(claimId);
      if (featureService.hasFeature(FEATURES.GET_LEGAL_PROCEEDING)) {
        props.requestGetJudgements(
          claimId,
          Number(props.currentTabInstance) === PROCEDURE_STEPS_INDEX['APPEAL']
            ? PROCEDURE_TYPES.APPEAL
            : PROCEDURE_TYPES.FIRST_INSTANCE,
          props.judiciaryProcessId,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.judiciaryProcessId,
    claimId,
    claimNumber,
    props.currentTabInstance,
  ]);
  useEffect(() => {
    if (props.judiciaryProcessId) {
      props.getLegalProceedingsSteps(claimId, props.judiciaryProcessId);
      if (featureService.hasFeature(FEATURES.GET_LEGAL_PROCEEDING)) {
        props.requestGetJudgements(
          claimId,
          Number(props.currentTabInstance) === PROCEDURE_STEPS_INDEX['APPEAL']
            ? PROCEDURE_TYPES.APPEAL
            : PROCEDURE_TYPES.FIRST_INSTANCE,
          props.judiciaryProcessId,
        );
      } else {
        if (
          Number(props.currentTabInstance) === PROCEDURE_STEPS_INDEX['APPEAL']
        ) {
          props.requestGetJudgementAdd(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );

          props.requestGetJudgementAddAppeal(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );

          props.requestGetExpertiseReportAppeal(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );

          props.requestGetExpertiseRaport(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );

          props.requestGetJudgementOnMerits(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );

          props.requestGetAppealOnMeritsMultiple(
            claimId,
            PROCEDURE_TYPES.APPEAL,
            props.judiciaryProcessId,
          );
        } else if (
          Number(props.currentTabInstance) ===
          PROCEDURE_STEPS_INDEX['FIRST_INSTANCE']
        ) {
          props.requestGetExpertiseRaport(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
          props.requestGetJudgementAdd(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
          props.requestGetJudgementOnMerits(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );

          props.requestGetJudgementOnMeritsMultiple(
            claimId,
            PROCEDURE_TYPES.FIRST_INSTANCE,
            props.judiciaryProcessId,
          );
        }
      }
      featureService.hasFeature(FEATURES.EVOLUTION_P3) &&
        props.requestFeeNotesByClaimNumb(claimNumber, [], true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    claimId,
    props.currentTabInstance,
    props.judiciaryProcessId,
    currentActiveTab,
    props.keycloakToken,
    props.claimRecap,
  ]);
  useEffect(() => {
    const assignedLawyers = get(
      props.claimRecap,
      ['claim', 'assignment'],
      [],
    ).map((el: any) => el.assignedLawyer);

    if (
      !isEmpty(props.claimRecap) &&
      assignedLawyers &&
      props.sagis_code &&
      !assignedLawyers.includes(props.sagis_code) &&
      !isJudiciaryProcessLawyerCode(props.civilProceeding, props.sagis_code)
    ) {
      routesHelper.pushTo(PAGES.LAWYER_ASSIGNMENTS)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap, props.sagis_code]);

  const isCivilProceedingCommercial = isCivilProceedingCommercialCheck(
    props.civilProceeding,
    props.judiciaryProcessId,
  );

  const labelsInstance = [...INSTANCE_LABELS_LAWYER];

  if (judgementOnMerits && judgementOnMerits.jom && judgementOnMerits.jom.jmc) {
    const contestationTypeNumber = judgementOnMerits.jom.jmc.type;
    const contestationTypes = get(
      props.listings,
      'judgementOnMeritsContestationTypes',
      [],
    );
    const contestationType = contestationTypes.find(
      type => type.id === contestationTypeNumber,
    );
    contestationType &&
      contestationType.title &&
      labelsInstance.push(contestationType.title);
  }

  useDeepCompareEffect(() => {
    if (!isEmpty(props.judgementAdd)) {
      props.requestGetDahirAmountCorpo(claimId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.judgementAdd, props.keycloakToken]);

  const isCivilProceeding = isCivilProceedingCheck(
    props.civilProceeding,
    props.judiciaryProcessId,
  );

  const judgementAddDocuments = useMemo(
    () =>
      getJudgementAddDocuments(
        get(props, 'judgementAddClone.judgementAddDocuments', []),
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [get(props, 'judgementAddClone.judgementAddDocuments', [])],
    // eslint-disable-next-line react-hooks/exhaustive-deps
  );

  const assignedLawyers = constructAssignedLawyer(
    props.claimRecap,
    props.civilProceeding,
    props.judiciaryProcessId,
  );
  const isAssignedLawyer =
    checkIsAssignedLawyer(assignedLawyers, props.sagis_code) &&
    !isBlockStatusClaim(props.policyInfo);

  const assignedLawyer = assignedLawyers.find(
    (el: string) => el === props.sagis_code,
  );
  return (
    <StyledSahamTabs>
      {featureService.hasFeature(FEATURES.JUDGEMENT_APPEAL) && (
        <LegalProceedingTabs
          currentTabIndex={currentActiveTab}
          labels={labelsInstance}
          setCurrentInstanceTab={props.setCurrentInstanceTab}
          onPressInstructions={props.onPressInstructions}
          isAssignedLawyer={props.isAssignedLawyer}
          instructions={props.instructions}
          onPressFeeNote={props.onPressFeeNote}
          isIntervenants={true}
        >
          <StyledSahamAppelTabs>
            <ToggleTabs
              currentTabIndex={props.currentTabLawyer || 0}
              labels={proceedingLabels(
                PROCEDURE_TYPES.FIRST_INSTANCE,
                props.judgementAdd,
                props,
                isCivilProceedingCommercial,
                judgementOnMerits,
                judgementOnMeritsMultiple,
                jomLabels,
                currentJomMultiple,
                appealOnMeritsMultiple,
                jomAppealLabels,
              )}
            >
              {isCivilProceedingCommercial &&
                !isEmpty(props.civilProceeding) && (
                  <CivilProceedingRecap
                    {...props}
                    isManager={false}
                    lossDate={get(props.claimRecap, 'claim.lossDate', null)}
                    handleOpenUpdateForm={
                      props.handleOpenUpdateFormCivilProceeding
                    }
                    sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                    sagisOpposingParties={extractOpposingParties(
                      get(props.sagisInfo, 'offeredRisks', []),
                    )}
                    isConsultation={false}
                  />
                )}
              <JudgementAdd
                {...props}
                victims={
                  isPendingApprovalClaim(props.claimRecap)
                    ? get(props.claimRecap, 'victims', [])
                    : filterVictim(get(props.claimRecap, 'victims', []))
                }
                vehicules={
                  isPendingApprovalClaim(props.claimRecap)
                    ? get(props.claimRecap, 'vehicules', [])
                    : filterVehicle(get(props.claimRecap, 'vehicules', []))
                }
                lossDate={get(props.claimRecap, 'claim.lossDate', null)}
                claimId={claimId}
                claimNumber={claimNumber}
                judgementAdd={props.judgementAddClone}
                isCivilProceeding={isCivilProceeding}
                stakeholders={stakeholders}
                assignedLawyer={assignedLawyer}
                isAssignedLawyer={isAssignedLawyer}
                resetUploadedDocument={props.resetUploadDocumentStore}
                loaders={props.loaders}
                sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                sagisOpposingParties={extractOpposingParties(
                  get(props.sagisInfo, 'offeredRisks', []),
                )}
                riskKey={get(
                  get(props.sagisInfo, 'offeredRisks', []).find(
                    (element: { riskName: string }) =>
                      element.riskName === rcCoporeal,
                  ),
                  'riskId',
                )}
              />
              {showExpertReport(props.judgementAdd) && (
                <LawyerExpertReport
                  {...props}
                  judgementAddDocuments={judgementAddDocuments}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  isAssignedLawyer={isAssignedLawyer}
                  assignedLawyers={assignedLawyers}
                  sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisInfo, 'offeredRisks', []),
                  )}
                  expertiseRaportFirstInstance={props.expertiseRaportAppeal}
                />
              )}
              {ShowExpertExpertise(
                props.expertExpertise,
                props.judiciaryProcessId,
                1,
              ) && (
                <ExpertReport
                  {...props}
                  expertisesVictim={getExpertExpertise(
                    props.expertExpertise,
                    props.judiciaryProcessId,
                    1,
                  )}
                  requestMakeDecisionMissionExpertise={() => {}}
                  claimId={claimId}
                  isLawyer={true}
                  claimNumber={claimNumber}
                  riskKey={get(
                    get(props.sagisInfo, 'offeredRisks', []).find(
                      (element: { riskName: string }) =>
                        element.riskName === rcCoporeal,
                    ),
                    'riskId',
                  )}
                  setOpenFeeNoteDialog={() => {}}
                />
              )}
              {((showJudgementOnMerits(
                props.expertiseReport,
                props.judgementAddClone,
              ) &&
                resolveDisplayJomForm(props.judgementOnMeritsMultiple)) ||
                !isEmpty(judgementOnMerits)) && (
                <JudgementOnMerits
                  {...props}
                  judgementAdd={get(
                    props.judgementAddClone,
                    'civilDocuments',
                    [],
                  )}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  judgementAddDocuments={get(
                    props.judgementAddClone,
                    'judgementAddDocuments',
                    [],
                  )}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  isManager={false}
                  isCivilProceeding={isCivilProceedingCommercial}
                  victims={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'victims', [])
                      : filterVictim(get(props.claimRecap, 'victims', []))
                  }
                  vehicules={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'vehicules', [])
                      : filterVehicle(get(props.claimRecap, 'vehicules', []))
                  }
                  setJomLabels={setJomLabels}
                  jomAssociatedVictims={associatedVictims}
                  setJomAssociatedVictims={setAssociatedVictims}
                  jomVictims={getJomVictims([
                    get(props.judgementOnMerits, 'judgementOnMerits'),
                    ...judgementOnMeritsMultiple,
                  ])}
                  jomVehicles={getJomVehicles([
                    get(props.judgementOnMerits, 'judgementOnMerits'),
                    ...judgementOnMeritsMultiple,
                  ])}
                  setJomAppealLabels={setJomAppealLabels}
                  setCurrentActiveTab={setCurrentActiveTab}
                  setCurrentJom={setCurrentJom}
                  isAssignedLawyer={isAssignedLawyer}
                  sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisInfo, 'offeredRisks', []),
                  )}
                  jomDeceasedVictims={getJomDeceasedVictims(
                    props.judgementAddClone,
                    get(judgementOnMerits, 'jom.id'),
                  )}
                  imagineDocuments={[]}
                  isConsultation={false}
                  judgementOnMeritsMultiple={get(
                    props.judgementOnMeritsMultiple,
                    'judgementOnMerits',
                    [],
                  )}
                />
              )}
              {sortJudgement(judgementOnMeritsMultiple).map((el: any) => (
                <JudgementOnMerits
                  {...props}
                  judgementAdd={get(
                    props.judgementAddClone,
                    'civilDocuments',
                    [],
                  )}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  judgementAddDocuments={resolveJudgementAddDocs(
                    get(props.judgementAddClone, 'judgementAddDocuments', []),
                    [get(props.judgementOnMerits, 'judgementOnMerits')],
                  )}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  judgementOnMerits={
                    (formatRenderJudgementOnMerits(
                      el as any,
                      props.judgementOnMeritsMultiple,
                    ) as unknown) as JudgementOnMeritsType
                  }
                  isManager={false}
                  isCivilProceeding={isCivilProceedingCommercial}
                  victims={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'victims', [])
                      : filterVictim(get(props.claimRecap, 'victims', []))
                  }
                  vehicules={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'vehicules', [])
                      : filterVehicle(get(props.claimRecap, 'vehicules', []))
                  }
                  setJomLabels={setJomLabels}
                  jomAssociatedVictims={associatedVictims}
                  jomDeceasedVictims={getJomDeceasedVictims(
                    props.judgementAddClone,
                    get(el, 'jom.id'),
                  )}
                  setJomAssociatedVictims={setAssociatedVictims}
                  isMultiple
                  jomVictims={getJomVictims([
                    get(props.judgementOnMerits, 'judgementOnMerits'),
                    ...judgementOnMeritsMultiple,
                  ])}
                  jomVehicles={getJomVehicles([
                    get(props.judgementOnMerits, 'judgementOnMerits'),
                    ...judgementOnMeritsMultiple,
                  ])}
                  setJomAppealLabels={setJomAppealLabels}
                  setCurrentActiveTab={setCurrentActiveTab}
                  setCurrentJom={setCurrentJom}
                  isAssignedLawyer={isAssignedLawyer}
                  sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisInfo, 'offeredRisks', []),
                  )}
                  judgementOnMeritsMultiple={get(
                    props.judgementOnMeritsMultiple,
                    'judgementOnMerits',
                    {},
                  )}
                  imagineDocuments={[]}
                  isConsultation={false}
                />
              ))}
              {jomLabels.map((el: any) => (
                <JudgementOnMerits
                  {...props}
                  judgementAdd={get(
                    props.judgementAddClone,
                    'civilDocuments',
                    [],
                  )}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  judgementAddDocuments={resolveJudgementAddDocs(
                    get(props.judgementAddClone, 'judgementAddDocuments', []),
                    [get(props.judgementOnMerits, 'judgementOnMerits')],
                  )}
                  allJudgementAddDocuments={get(
                    props.judgementAddClone,
                    'judgementAddDocuments',
                    [],
                  )}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  judgementOnMerits={{} as JudgementOnMeritsType}
                  isManager={false}
                  isCivilProceeding={isCivilProceedingCommercial}
                  victims={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'victims', [])
                      : filterVictim(get(props.claimRecap, 'victims', []))
                  }
                  vehicules={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'vehicules', [])
                      : filterVehicle(get(props.claimRecap, 'vehicules', []))
                  }
                  setJomLabels={setJomLabels}
                  jomAssociatedVictims={associatedVictims}
                  setJomAssociatedVictims={setAssociatedVictims}
                  isMultiple
                  setJomAppealLabels={setJomAppealLabels}
                  isAssignedLawyer={isAssignedLawyer}
                  sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisInfo, 'offeredRisks', []),
                  )}
                  jomDeceasedVictims={getJomDeceasedVictims(
                    props.judgementAddClone,
                    get(el, 'jom.id'),
                  )}
                  judgementOnMeritsMultiple={get(
                    props.judgementOnMeritsMultiple,
                    'judgementOnMerits',
                    [],
                  )}
                  imagineDocuments={[]}
                  isConsultation={false}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              ))}
            </ToggleTabs>
          </StyledSahamAppelTabs>
          <StyledSahamAppelTabs>
            <ToggleTabs
              currentTabIndex={0}
              labels={proceedingLabels(
                PROCEDURE_TYPES.APPEAL,
                props.judgementAdd,
                props,
                isCivilProceedingCommercial,
                judgementOnMerits,
                judgementOnMeritsMultiple,
                jomLabels,
                currentJomMultiple,
                appealOnMeritsMultiple,
                jomAppealLabels,
              )}
            >
              <AppealAdd
                {...props}
                victims={
                  isPendingApprovalClaim(props.claimRecap)
                    ? get(props.claimRecap, 'victims', [])
                    : filterVictim(get(props.claimRecap, 'victims', []))
                }
                vehicules={
                  isPendingApprovalClaim(props.claimRecap)
                    ? get(props.claimRecap, 'vehicules', [])
                    : filterVehicle(get(props.claimRecap, 'vehicules', []))
                }
                resetUploadedDocument={props.resetUploadDocumentStore}
                judgementAdd={props.judgementAddClone}
                claimId={claimId}
                claimNumber={claimNumber}
                stakeholders={stakeholders}
                assignedLawyer={assignedLawyer}
                lossDate={get(props.claimRecap, 'claim.lossDate')}
                isCivilProceeding={isCivilProceedingCommercial}
                isAssignedLawyer={isAssignedLawyer}
                sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                sagisOpposingParties={extractOpposingParties(
                  get(props.sagisInfo, 'offeredRisks', []),
                )}
                riskKey={get(
                  get(props.sagisInfo, 'offeredRisks', []).find(
                    (element: { riskName: string }) =>
                      element.riskName === rcCoporeal,
                  ),
                  'riskId',
                )}
                dahirAmount={[]}
              />
              <LawyerExpertReportAppeal
                {...props}
                judgementAddDocuments={judgementAddDocuments}
                resetUploadedDocument={props.resetUploadDocumentStore}
                claimId={claimId}
                claimNumber={claimNumber}
                isAssignedLawyer={isAssignedLawyer}
                assignedLawyers={assignedLawyers}
                sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                sagisOpposingParties={extractOpposingParties(
                  get(props.sagisInfo, 'offeredRisks', []),
                )}
              />
              {ShowExpertExpertise(
                props.expertExpertise,
                props.judiciaryProcessId,
                2,
              ) && (
                <ExpertReport
                  expertisesVictim={getExpertExpertise(
                    props.expertExpertise,
                    props.judiciaryProcessId,
                    2,
                  )}
                  requestMakeDecisionMissionExpertise={() => {}}
                  claimId={claimId}
                  isLawyer={true}
                  feeNotes={props.feeNotes}
                  claimNumber={claimNumber}
                  riskKey={get(
                    get(props.sagisInfo, 'offeredRisks', []).find(
                      (element: { riskName: string }) =>
                        element.riskName === rcCoporeal,
                    ),
                    'riskId',
                  )}
                  setOpenFeeNoteDialog={() => {}}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              )}
              <JudgementOnMeritsAppeal
                {...props}
                judgementAdd={props.judgementAddClone}
                claimId={claimId}
                claimNumber={claimNumber}
                judgementAddDocuments={get(
                  props.judgementAddClone,
                  'judgementAddDocuments',
                  [],
                )}
                resetUploadedDocument={props.resetUploadDocumentStore}
                isManager={false}
                isCivilProceeding={isCivilProceedingCommercial}
                victims={
                  isPendingApprovalClaim(props.claimRecap)
                    ? get(props.claimRecap, 'victims', [])
                    : filterVictim(get(props.claimRecap, 'victims', []))
                }
                vehicules={
                  isPendingApprovalClaim(props.claimRecap)
                    ? get(props.claimRecap, 'vehicules', [])
                    : filterVehicle(get(props.claimRecap, 'vehicules', []))
                }
                jomDeceasedVictims={getJomDeceasedVictimsAppeal(
                  props.judgementAddClone,
                  get(props.judgementOnMerits, 'judgementOnMerits.jom.id'),
                )}
                isFirst={!isEmpty(props.judgementOnMerits)}
                isAssignedLawyer={isAssignedLawyer}
                sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                sagisOpposingParties={extractOpposingParties(
                  get(props.sagisInfo, 'offeredRisks', []),
                )}
                appealOnMeritsMultiple={get(
                  props.appealOnMeritsMultiple,
                  'judgementOnMerits',
                  [],
                )}
                imagineDocuments={[]}
                isConsultation={false}
              />
              {sortJudgement(appealOnMeritsMultiple).map((el: any) => (
                <JudgementOnMeritsAppeal
                  {...props}
                  judgementAdd={props.judgementAddClone}
                  civilProceeding={props.civilProceeding}
                  listings={props.listings}
                  judgementAddClone={props.judgementAddClone}
                  claimId={claimId}
                  judgementAddAppeal={props.judgementAddAppeal}
                  requestGetJudgementAddAppeal={
                    props.requestGetJudgementAddAppeal
                  }
                  requestGetJudgementAdd={props.requestGetJudgementAdd}
                  claimNumber={claimNumber}
                  judgementAddDocuments={get(
                    props.judgementAddClone,
                    'judgementAddDocuments',
                    [],
                  )}
                  requestCreateJudgementOnMerits={
                    props.requestCreateJudgementOnMerits
                  }
                  uploadDocument={props.uploadDocument}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  documentId={props.documentId}
                  setDocumentId={props.setDocumentId}
                  judgementOnMerits={
                    {
                      judgementOnMerits: { ...el },
                      beneficiaries: [
                        ...get(
                          props.judgementOnMeritsMultiple,
                          'beneficiaries',
                          [],
                        ),
                      ],
                    } as any
                  }
                  requestGetDahirAmount={props.requestGetDahirAmount}
                  dahirAmount={props.dahirAmount}
                  policyInfo={props.policyInfo}
                  judiciaryProcessId={props.judiciaryProcessId}
                  isManager={false}
                  isCivilProceeding={isCivilProceedingCommercial}
                  victims={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'victims', [])
                      : filterVictim(get(props.claimRecap, 'victims', []))
                  }
                  requestAddJudgementOnMeritsSupportDocument={
                    props.requestAddJudgementOnMeritsSupportDocument
                  }
                  requestValidateJudgementOnMerits={
                    props.requestValidateJudgementOnMerits
                  }
                  vehicules={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'vehicules', [])
                      : filterVehicle(get(props.claimRecap, 'vehicules', []))
                  }
                  currentJudiciaryProcess={props.currentJudiciaryProcess}
                  jomDeceasedVictims={getJomDeceasedVictimsAppeal(
                    props.judgementAddClone,
                    get(el, 'jom.id'),
                  )}
                  isMultiple
                  isAssignedLawyer={isAssignedLawyer}
                  setDialogOpenFirmReference={props.setDialogOpenFirmReference}
                  sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisInfo, 'offeredRisks', []),
                  )}
                  expertiseReport={props.expertiseReport}
                  expertiseRaportAppeal={props.expertiseRaportAppeal}
                  appealOnMeritsMultiple={get(
                    props.appealOnMeritsMultiple,
                    'judgementOnMerits',
                    [],
                  )}
                  imagineDocuments={[]}
                  isConsultation={false}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              ))}
              {jomAppealLabels.map((el: any) => (
                <JudgementOnMeritsAppeal
                  {...props}
                  judgementAdd={props.judgementAddClone}
                  claimId={claimId}
                  claimNumber={claimNumber}
                  judgementAddDocuments={get(
                    props.judgementAddClone,
                    'judgementAddDocuments',
                    [],
                  )}
                  resetUploadedDocument={props.resetUploadDocumentStore}
                  judgementOnMerits={{} as JudgementOnMeritsType}
                  isManager={false}
                  isCivilProceeding={isCivilProceedingCommercial}
                  victims={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'victims', [])
                      : filterVictim(get(props.claimRecap, 'victims', []))
                  }
                  vehicules={
                    isPendingApprovalClaim(props.claimRecap)
                      ? get(props.claimRecap, 'vehicules', [])
                      : filterVehicle(get(props.claimRecap, 'vehicules', []))
                  }
                  currentJom={currentJom}
                  jomDeceasedVictims={getJomDeceasedVictims(
                    props.judgementAddClone,
                    get(currentJom, 'judgementOnMerits.jom.id'),
                  )}
                  isMultiple
                  isAssignedLawyer={isAssignedLawyer}
                  sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                  sagisOpposingParties={extractOpposingParties(
                    get(props.sagisInfo, 'offeredRisks', []),
                  )}
                  appealOnMeritsMultiple={get(
                    props.appealOnMeritsMultiple,
                    'judgementOnMerits',
                    [],
                  )}
                  imagineDocuments={[]}
                  isConsultation={false}
                />
              ))}
            </ToggleTabs>
          </StyledSahamAppelTabs>
          {featureService.hasFeature(
            FEATURES.JUDGEMENT_ON_MERITS_CONTESTATION,
          ) &&
            !isEmpty(get(judgementOnMerits, 'jom.jmc', [])) && (
              <Contestation
                listings={props.listings}
                judgementOnMerits={props.judgementOnMerits['judgementOnMerits']}
                contestationOwners={
                  props.listings.judgementOnMeritsContestationOwners
                }
                documentId={props.documentId}
                uploadDocument={props.uploadDocument}
                resetUploadedDocument={props.resetUploadDocumentStore}
                uploadedDocument={props.uploadedDocument}
                setDocumentId={props.setDocumentId}
                isLawyer
                updateContestation={props.updateContestation}
                requestUploadContestationDocument={
                  props.requestUploadContestationDocument
                }
                claimNumber={claimNumber}
                lossDate={get(props.claimRecap, 'claim.lossDate')}
                claim={props.claimRecap}
                isAssignedLawyer={isAssignedLawyer}
                sagisVictimInfo={get(props.sagisInfo, 'victims', [])}
                isConsultation={false}
                requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
              />
            )}
        </LegalProceedingTabs>
      )}
    </StyledSahamTabs>
  );
};

export default injectIntl(LegalProceedingsPage);
